// extracted by mini-css-extract-plugin
export default {"container":"topIndustryPlayers_container__jcyPu","companyRevenue":"topIndustryPlayers_companyRevenue__t57z7"};